// extracted by mini-css-extract-plugin
export default {"container":"_4uppKiSsJFIRB8VhXEFD","header":"EpdQvVbJ7pm4Vfi1VT9o","emptyState":"WJRC70O8XgEu0Fm6lcUg","addVariationButton":"zYYlEYTqinb6EyMdMB2Q"};